import { API } from "./axios.service";

export class LookupService {
  static async getAllFeatureGrups(): Promise<any> {
    return API.get("api/v1/lookup/user-feature-group");
  }

  static async addNewPrevilige(data: any): Promise<any> {
    return API.post("api/v1/lookup/privileges", data);
  }

  static async getPrevilige(): Promise<any> {
    return API.get("api/v1/lookup/privileges");
  }

  static async updatePrevilige(data: any): Promise<any> {
    return API.put(`api/v1/lookup/privileges`, data);
  }

  static async getTicketsInfo(data:any): Promise<any> {
    return API.get("api/v1/notification/ticket",{params:data});
  }
  static async updateTicketsInfo(data: any): Promise<any> {
    return API.put(`api/v1/notification/ticket/update`, data);
  }
  static async getLogsData(): Promise<any> {
    return API.get(`api/v1/log/files`);
  }

  static async singleLogsData(id:any): Promise<any> {
    return API.get(`api/v1/log/content/${id}`);
  }

  static async cancelOrder(data:any): Promise<any> {
    return API.post(`/ondc/liquidate_order`, data);
  }

}
